"use strict";
import { config, errorOptions } from '../_config'


export const refugeService = {
  getAll,
  getRefuge,
  postRefuge,
  startBooking,
  removeRefuge,
  postCustomerData,
  addPreBookingServices,
  getBookingPayment,
  notifyPayment,
  getExpirationTime
}
async function startBooking(lang){
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow',
    referrer: 'no-referrer',
    credentials:'include',
    cache: 'no-cache',
    mode: 'cors'
  }
  const rawResponse = await fetch(`${config.apiUrl}/reservas/startBooking?lang=${lang}`, requestOptions)
    .catch( err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    } )
    const content = await rawResponse.json().catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const data = await content

  return data
}
async function getAll(  ) {
  const requestOptions = {
    method: 'GET',
    // En Firefox no funciona
    //headers: { 'Content-Type': 'application/json' },
    mode: 'cors'
  }
  const rawResponse = await fetch(`${config.apiUrl}/refugios/getAll?booking&` + Date.now().toString(), requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    });

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })
  const data = await  content
  return  data.result
}
async function getRefuge(id) {
  const requestOptions = {
    method: 'GET',
    // En Firefox no funciona
    //headers: { 'Content-Type': 'application/json' },
    mode: 'cors'
  }
  const rawResponse = await fetch(`${config.apiUrl}/refugios/get/${id}`, requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })

  const data = await content;

  if (data.result){
    const rooms = await _getRooms(id);
    data.result.habitaciones = rooms;
  }

  return data.result
}
async function _getRooms(id) {
  const requestOptions = {
    method: 'GET',
    // En Firefox no funciona
    //headers: { 'Content-Type': 'application/json' },
    mode: 'cors'
  }
  const rawResponse = await fetch(`${config.apiUrl}/refugios/get/${id}/getPlazas/`, requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
    console.log(err, toastr)
  })

  const data = await content

  let habitaciones = []
  if (data.response){
    for (var a in data.result) {
      let h = data.result[a]
      h.plazas = Object.values(h.plazas)
      habitaciones.push(h)
    }

    return habitaciones
  }
}
async function postRefuge(ref){
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    body: ref
  }
  const rawResponse = await fetch(`${config.apiUrl}/reservas/preBooking`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
  })
  const data = await content

  return data
}
async function removeRefuge(ref){
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    body: ref
  }

  const rawResponse = await fetch(`${config.apiUrl}/reservas/modifyPreBooking`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
  })
  const data = await content

  return data
}
async function postCustomerData(customer) {
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    body: customer
  }
  const rawResponse = await fetch(`${config.apiUrl}/reservas/setPreBookingData`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
  })
  const data = await content

  return data
}
async function addPreBookingServices(serv){
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    body: serv
  }
  const rawResponse = await fetch(`${config.apiUrl}/reservas/addPreBookingServices`, requestOptions)
  const content = await rawResponse.json()

  const data = await content
  return await data
}
async function getBookingPayment(){
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include'
  }
  const rawResponse = await fetch(`${config.apiUrl}/reservas/getBookingPayment`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
  })
  const data = await content
  return data
}
async function notifyPayment(lang){
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    body: lang
  }
  const rawResponse = await  fetch(`${config.apiUrl}/reservas/setBookingToTPV`, requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
    })

  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
  })
  const data = await content
  return data
}
async function getExpirationTime(){
  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    credentials:'include',
    headers:{
      'Content-Type':'application/json; charset=UTF-8'
    }
  }

  const rawResponse = await fetch(`${config.apiUrl}/reservas/getTimeMakeBooking`,requestOptions)
    .catch(err => {
      toastr.options = errorOptions
      toastr["error"]("Error general. Por favor refresca la página.")
      console.log(err, toastr)
    })
  const content = await rawResponse.json().catch(err => {
    toastr.options = errorOptions
    toastr["error"]("Error general. Por favor refresca la página.")
  })
  const data = await content
  return data
}



// WEBPACK FOOTER //
// ./src/_services/refuges.service.js